import { EventEmitter } from '@angular/core';
import { NotifyEvent, RefreshEvent } from './detail-page';

export abstract class ApiService {
  public readonly refreshEvent = new EventEmitter<RefreshEvent>();
  public readonly notifyConnectionErrorEvent = new EventEmitter<NotifyEvent.CONNECTION_ERROR>();
}
